import { render, staticRenderFns } from "./data-download.vue?vue&type=template&id=db15111c&scoped=true"
import script from "./data-download.vue?vue&type=script&lang=js"
export * from "./data-download.vue?vue&type=script&lang=js"
import style0 from "./data-download.vue?vue&type=style&index=0&id=db15111c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db15111c",
  null
  
)

export default component.exports